// Angular
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
// Chart
import {
  Chart,
  registerables,
  ChartConfiguration
} from 'chart.js';

Chart.register(...registerables);

// LayoutConfig
import { LayoutConfigService } from '../../layout/services/layout-config.service';

export interface SparklineChartOptions {
  data: number[];
  color: string;
  border: number;
  fill?: boolean;
  tooltip?: boolean;
}

/**
 * Configure sparkline chart
 */
@Directive({
  selector: '[ktSparklineChart]',
  exportAs: 'ktSparklineChart'
})
export class SparklineChartDirective implements AfterViewInit {
  @Input() options: SparklineChartOptions;

  private chart: Chart;

  constructor(private el: ElementRef, private layoutConfigService: LayoutConfigService) {}

  ngAfterViewInit(): void {
    this.initChart(
      this.el.nativeElement,
      this.options.data,
      this.options.color,
      this.options.border,
      this.options.fill,
      this.options.tooltip
    );
  }

  initChart(src: any, data: number[], color: string, border: number, fill?: boolean, tooltip?: boolean) {
    if (!src) {
      return;
    }

    fill = typeof fill !== 'undefined' ? fill : false;
    tooltip = typeof tooltip !== 'undefined' ? tooltip : false;

    const config: ChartConfiguration<'line'> = {
      type: 'line',
      data: {
        labels: [
          'January', 'February', 'March', 'April', 'May',
          'June', 'July', 'August', 'September', 'October'
        ],
        datasets: [{
          label: '',
          borderColor: color,
          borderWidth: border,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 12,
          pointBackgroundColor: 'rgba(0,0,0,0)',
          pointBorderColor: 'rgba(0,0,0,0)',
          pointHoverBackgroundColor: this.layoutConfigService.getConfig('colors.state.danger'),
          pointHoverBorderColor: 'rgba(0,0,0,0.1)',
          fill: fill,
          data: data
        }]
      },
      options: {
        plugins: {
          title: {
            display: false
          },
          tooltip: {
            enabled: tooltip
          },
          legend: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        hover: {
          mode: 'index'
        },
        scales: {
          x: {
            display: false,
            grid: {
              display: false
            },
            title: {
              display: true,
              text: 'Month'
            }
          },
          y: {
            display: false,
            grid: {
              display: false
            },
            title: {
              display: true,
              text: 'Value'
            },
            suggestedMin: 0 // ✅ Correto: substitui beginAtZero
          }
        },
        elements: {
          point: {
            radius: 4,
            borderWidth: 12
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 5,
            bottom: 0
          }
        }
      }
    };

    this.chart = new Chart(src, config);
  }

  getChart() {
    return this.chart;
  }
}
